import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-wrap text-darkgray-900 pb-7 mb-7 border-b border-gray-40 space-y-1 lg:space-y-0" }
const _hoisted_3 = { class: "w-full lg:w-1/2" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Date Booked")
], -1)
const _hoisted_6 = { class: "col-span-1 text-right" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Time Booked")
], -1)
const _hoisted_9 = { class: "col-span-1 text-right" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "flex flex-wrap" }
const _hoisted_12 = { class: "w-full lg:w-1/2" }
const _hoisted_13 = { class: "lg:pb-7 mb-7 lg:border-b lg:border-gray-40" }
const _hoisted_14 = { class: "list-disc pl-5" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, "N/A", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "lg:mb-0 mb-7" }
const _hoisted_21 = { class: "mt-12 hidden lg:flex" }
const _hoisted_22 = { class: "w-full lg:w-1/2 lg:pl-12" }
const _hoisted_23 = { class: "rounded-[10px] bg-white py-7 px-5 text-darkgray-900" }
const _hoisted_24 = { class: "grid grid-cols-12 gap-2.5 border-b border-gray-40 pb-4 mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
], -1)
const _hoisted_26 = { class: "col-span-8 text-right" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-on")
], -1)
const _hoisted_28 = { class: "col-span-8 text-right" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "N/A", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
], -1)
const _hoisted_34 = { class: "col-span-8 text-right" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
], -1)
const _hoisted_36 = { class: "col-span-8 text-right" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
], -1)
const _hoisted_38 = { class: "col-span-8 text-right" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
], -1)
const _hoisted_40 = { class: "col-span-8 text-right" }
const _hoisted_41 = { class: "grid grid-cols-12 gap-2.5 text-primary-500" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-xl" }, "Total")
], -1)
const _hoisted_43 = { class: "col-span-6 text-right" }
const _hoisted_44 = { class: "font-bold text-xl" }
const _hoisted_45 = { class: "mt-6" }
const _hoisted_46 = { class: "mt-2" }
const _hoisted_47 = { class: "mt-12 flex lg:hidden" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, "Your booking appointment has been received.", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, "A medical questionnaire has been provided in your appointment details, which you may access by clicking the button below. Please ensure that this form has been filled before your appointment.", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Thank you!", -1)

import PortalLayout from '@/layouts/PortalLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import GeneralModal from '@/components/GeneralModal.vue';
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import { useRoute } from 'vue-router';

import { ref, computed, onMounted, watch } from 'vue';
import patient from "@/classes/UserData";
import { format, parse } from 'date-fns';
import { formatter } from '@/helpers/NumberHelper';

import booking from "@/classes/Booking";
import ButtonComponent from '@/components/ButtonComponent.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

const timezoneOffset = 8; // Philippines time zone is UTC+8

export default /*#__PURE__*/_defineComponent({
  __name: 'ShowSoftBookingPage',
  setup(__props) {

const route = useRoute();

const patientData = computed(() => patient.getCurrentUser())

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const showSuccess = ref(false)
const showConfirmation = ref(false)
const appointment = ref()
const bookingId = ref(route.params.id as unknown as string);

const startAndEndTime = computed(() => {
    if(appointment.value.booking_start_time && appointment.value.booking_end_time) {
        return format(parse(appointment.value.booking_start_time, 'hh:mm:ss', new Date()), 'h:mm a') + ' - ' + format(parse(appointment.value.booking_end_time, 'hh:mm:ss', new Date()), 'h:mm a')
    } else {
        return "--"
    }
});

const show = ref(false);
const hybrainBookingId = ref(null);

const selectedTime = ref(null)
const fullyBookedDates = ref([]);
const unformattedTimeSlots = ref([]);
const timeSlots = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000 + timezoneOffset * 60 * 60 * 1000); // For 3 days advance booking

const minDate = computed(() => threeDaysLater.toISOString().slice(0, 10));
const from = ref(null);
const to = ref(null);

const selectedDate = ref(minDate.value)

const payload = ref({
    soft_booking_id: null,
    is_patient_portal: true,
    patient_id: patientData.value.patient_id,
    branch_id: null,
    package_id: null,
    package_fee: null,
    other_charges_line: null,
    other_charges_fee: null,
    booking_date: null,
    booking_start_time: null,
    booking_end_time: null,
    // For Validation
    package_name: null,
    branch_name: null,
    branch_address: null,
    riders: [],
});

const soft_payload = ref({
    id: null,
    branch_id: null,
    booking_date: null,
    booking_start_time: null,
    booking_end_time: null,
})

const fetchSelectedAppointment = () => {
    loader.value = true
    
    patient.fetchSoftBooking(bookingId.value)
        .then((result: any) => {
            loader.value = false;
            appointment.value = result.data;

            initPayload();
            fetchDateAndTime();
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const initPayload = () => {
    payload.value.soft_booking_id = appointment.value.id;
    payload.value.branch_id = appointment.value.branch.id;
    payload.value.package_id = appointment.value.package_id;
    payload.value.package_fee = appointment.value.package_fee;
    payload.value.other_charges_line = appointment.value.other_charges_line;
    payload.value.other_charges_fee = appointment.value.other_charges_fee;

    // For Validations
    payload.value.branch_name = appointment.value.branch.name;
    payload.value.branch_address = appointment.value.branch.address_line;
    payload.value.package_name = appointment.value.package.name;
    payload.value.riders = appointment.value.riders;

    if(appointment.value.booking_date) {
        // payload.value.booking_date = selectedDate.value;
        payload.value.booking_date = appointment.value.booking_date;
    }

    if(appointment.value.booking_start_time && appointment.value.booking_start_time) {
        // selectedTime.value = `${formatTime(appointment.value.booking_start_time)}-${formatTime(appointment.value.booking_end_time)}`
        payload.value.booking_start_time = appointment.value.booking_start_time;
        payload.value.booking_end_time = appointment.value.booking_end_time;
    }

    // Soft Booking
    soft_payload.value.id = appointment.value.id;
    soft_payload.value.branch_id = appointment.value.branch.id;
}

const formatTime = (time) => {
  const [hours, minutes] = time.split(":");
  const suffix = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // handle midnight (00:00:00) as 12 AM
  return `${formattedHours}:${minutes} ${suffix}`;
};

const backToAppointment = () => {
    window.location.replace('appointment')
}

const formatTimeSlots = () => {
    timeSlots.value = [];
    for(const unformattedTimeSlot in unformattedTimeSlots.value) {
        unformattedTimeSlots.value[unformattedTimeSlot].forEach(slot => {
            if(slot.available_slots != 0) {
                timeSlots.value.push(slot);
            }
        });

    }
}

const fetchDateAndTime = () => {
    loader.value = true;
    
    const payload = {
        branch_id: soft_payload.value.branch_id,
        selected_date: new Date(selectedDate.value).toISOString().split('T')[0],
        from: from.value,
        to: to.value,
    }
    booking.getTimeSlots(payload)
        .then((result: any) => {
            loader.value = false
            fullyBookedDates.value = result.data.response.fully_booked_dates;         
            unformattedTimeSlots.value = result.data.response.time_slots; 
            
            if(selectedDate.value) {
                formatTimeSlots();
            }
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const updateMonth = (val = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
   // Fetch fetchDateAndTime for Active Month
    if(soft_payload.value.branch_id) {
        fetchDateAndTime();
    }
}

const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

const selectTimeSlot = (val) => {
    if(val) {
        soft_payload.value.booking_start_time = val.split('-')[0];
        soft_payload.value.booking_end_time = val.split('-')[1];
    }
}

watch(
    () => selectedTime.value,
    (val) => {
        if(val)
        selectTimeSlot(val);
    },
    { immediate: true }
);

watch(
    () => selectedDate.value,
    (val) => {
        if(val)
            // selectedTime.value = null;
            soft_payload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
            updateMonth();
    },
    { immediate: true }
);

const submitBooking = () => {
    loader.value = true;
    
    booking.submitBooking(payload.value)
    .then((result: any) => {
            loader.value = false;
            show.value = true;

            hybrainBookingId.value = result.data.response.response.booking_id;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const bookAnother = () => {
    window.location.href = '/booking'
}
const viewBoking = () => {
    show.value = false
    window.location.replace(`/appointment/show/${hybrainBookingId.value}`);
}

const updateBooking = () => {
    loader.value = true;


    booking.updateSoftBooking(soft_payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;

                fetchSelectedAppointment();
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted(() => { fetchSelectedAppointment() })


return (_ctx: any,_cache: any) => {
  return (appointment.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(PortalLayout, {
          title: appointment.value.package.name,
          "hide-notification": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(format)(new Date(appointment.value.booking_date), 'LLLL dd, yyyy')), 1)
                  ]),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(startAndEndTime.value), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    (appointment.value.package.items.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value.package.items, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("li", null, _toDisplayString(item.item_name), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (selectedDate.value)
                    ? (_openBlock(), _createBlock(DatePicker, {
                        key: 0,
                        modelValue: selectedDate.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                        label: "Booking Date",
                        placeholder: "MM/DD/YYYY",
                        "min-date": minDate.value,
                        "fully-booked-dates": fullyBookedDates.value,
                        "hide-offset-dates": "",
                        "highlight-disabled-days": "",
                        onUpdateMonth: updateMonth
                      }, null, 8, ["modelValue", "min-date", "fully-booked-dates"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(MultiselectInput, {
                    modelValue: selectedTime.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTime).value = $event)),
                    label: "Booking Time",
                    placeholder: "Booking Time",
                    options: timeSlots.value
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(backToAppointment, ["prevent"]),
                    class: "text-primary-500 font-bold flex items-center cursor-pointer"
                  }, [
                    _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                    _createTextVNode(" Go back ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", null, _toDisplayString(appointment.value.branch.name), 1)
                    ]),
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", null, _toDisplayString(appointment.value.package.name), 1),
                      (appointment.value.other_charges_line.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value.other_charges_line, (rider) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: rider.item_id
                              }, [
                                _createElementVNode("p", null, _toDisplayString(rider.item_name), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                    ]),
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("p", null, _toDisplayString(_unref(format)(new Date(appointment.value.booking_date), 'LLLL dd, yyyy')), 1)
                    ]),
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("p", null, _toDisplayString(startAndEndTime.value), 1)
                    ]),
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(appointment.value.package_fee)), 1)
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(appointment.value.other_charges_fee)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, _toDisplayString(_unref(formatter).format(appointment.value.total_fee)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(ButtonComponent, {
                      disabled: loader.value,
                      onClick: _withModifiers(updateBooking, ["prevent"]),
                      class: "w-full",
                      text: "Update Soft Booking"
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(ButtonComponent, {
                      disabled: loader.value,
                      onClick: _withModifiers(submitBooking, ["prevent"]),
                      class: "w-full",
                      text: "Submit Soft Booking"
                    }, null, 8, ["disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(backToAppointment, ["prevent"]),
                    class: "text-primary-500 font-bold flex items-center cursor-pointer"
                  }, [
                    _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                    _createTextVNode(" Go back ")
                  ])
                ])
              ])
            ]),
            _createVNode(GeneralModal, {
              width: "w-[548px]",
              "check-icon": "",
              title: "Booking Confirmed!",
              "action-text": "View Appointment",
              "cancel-text": "Book another",
              show: show.value,
              onClose: bookAnother,
              onConfirm: viewBoking
            }, {
              content: _withCtx(() => [
                _hoisted_48,
                _hoisted_49,
                _hoisted_50,
                _hoisted_51,
                _hoisted_52
              ]),
              _: 1
            }, 8, ["show"]),
            (loader.value)
              ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(ErrorModal, {
              width: "w-[548px]",
              title: "Error",
              "action-text": "Close",
              "cancel-text": "Go back",
              show: showError.value,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
              onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(errorMsg.value), 1)
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(SuccessModal, {
              show: showSuccess.value,
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
              onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
              "action-text": "Confirm",
              title: "Booking Submitted!",
              content: "Booking has been updated successfully"
            }, null, 8, ["show"]),
            _createVNode(ConfirmationModal, {
              show: showConfirmation.value,
              onCancel: _cache[6] || (_cache[6] = ($event: any) => (showConfirmation.value = false)),
              onConfirm: _cache[7] || (_cache[7] = ($event: any) => {showConfirmation.value = false; _ctx.updateSoftBooking() }),
              "cancel-text": "Cancel",
              "action-text": "Confirm",
              title: "Submit Booking?",
              content: "Are you sure you wish to update this booking?"
            }, null, 8, ["show"])
          ]),
          _: 1
        }, 8, ["title"])
      ]))
    : _createCommentVNode("", true)
}
}

})